// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2jx7K","buttonFooter":"styles_buttonFooter__2d4mD","addFooter":"styles_addFooter__3EgFd"};